import { render, staticRenderFns } from "./RedeemAssetModal.vue?vue&type=template&id=2a023b03&scoped=true&"
import script from "./RedeemAssetModal.vue?vue&type=script&lang=js&"
export * from "./RedeemAssetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a023b03",
  null
  
)

export default component.exports